import {
    SpacingToken,
    UiStack,
    UiText,
} from '@experiences/ui-common';
import CheckIcon from '@mui/icons-material/Check';
import { Button } from '@mui/material';
import { makeStyles } from '@mui/styles';
import createStyles from '@mui/styles/createStyles';
import { FontVariantToken } from '@uipath/apollo-core';
import React, {
    useCallback,
    useState,
} from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import { useIntl } from 'react-intl';

const useStyles = makeStyles(theme =>
    createStyles({
        configContents: {
            padding: theme.spacing(1),
            overflowWrap: 'break-word',
            border: `1px solid ${theme.palette.divider}`,
        },
    })
);

export interface RelayClientConfigDialogProps {
    configContents: string;
}

const RelayClientConfigDialog: React.FC<RelayClientConfigDialogProps> = ({ configContents }) => {
    const classes = useStyles();
    const { formatMessage: translate } = useIntl();
    const [ showCopied, setShowCopied ] = useState(false);

    const onCopy = useCallback(() => {
        setShowCopied(true);
        setTimeout(() => setShowCopied(false), 2000);
    }, []);

    return (
        <UiStack
            direction="column"
            gap={SpacingToken.M}>
            <UiText variant={FontVariantToken.fontSizeMBold}>
                {translate({ id: 'CLIENT_RELAY_CONFIG_COPY_INFO' })}
            </UiText>
            <div className={classes.configContents}>
                <UiText>
                    {configContents}
                </UiText>
            </div>
            <UiStack
                justify="end"
                gap={SpacingToken.XS}
            >
                <CopyToClipboard text={configContents}>
                    <Button
                        variant="outlined"
                        data-cy="copy-button"
                        onClick={() => onCopy()}
                        startIcon={showCopied ? <CheckIcon
                            data-cy="ui-copy-button-success-icon"
                            data-testid="ui-copy-button-success-icon" /> : undefined}
                    >
                        {showCopied ? translate({ id: 'CLIENT_COPIED' }) : translate({ id: 'CLIENT_COPY' })}
                    </Button>
                </CopyToClipboard>
            </UiStack>
        </UiStack>);
};

export default RelayClientConfigDialog;
